import React, { Component } from "react";
import Breadcrumb from "../../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthDatatable";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import "./monthly-invoice.css";
import "./wholesale-kido.css";
import { FileText, Plus, RefreshCw, Trash2 } from "react-feather";
import {
  getAllEmployeeRedux,
  uploadSourcingRedux,
  getAllSourcingMonthStatsRedux,
  ensureCurrentMonthStatsRedux,
  recomputeSourcingMonthStatsRedux,
} from "../../../../actions/index";
import { sendNotifications } from "../../../../firebase/fcmRestApi";
import {
  uploadImage,
  updateImage,
  deleteImage,
} from "../../../../firebase/firebase.utils";
import firebase from "firebase/app";
import { connect } from "react-redux";
import man from "../../plus image.jpeg";

const emptyProductRow = () => ({
  id: `${Date.now()}${Math.floor(Math.random() * 1000)}`,
  imageUrl: "",
  productName: "",
  priceRmb: "",
  quantity: "",
});

export class SoldMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agent: "",
      totalRmb: "",
      sellRate: "",
      buyRate: "",
      shipping: "",
      productLink: "",
      productDetails: "",
      productName: "",
      productsArray: [],
      totalPaid: 0,
      buyingCost: 0,
      finalProfit: 0,
      customer: "",
      customerUid: "",
      cursor: -1,
      country: "",
      agentPaid: 0,
      initialProfit: 0,
      algProfit: 0,
      recalculating: false,
    };
  }

  handleRecalculateStats = async () => {
    this.setState({ recalculating: true });
    await this.props.recomputeSourcingMonthStatsRedux();
    this.setState({ recalculating: false });
  };

  addProductRow = () => {
    this.setState({
      productsArray: [...this.state.productsArray, emptyProductRow()],
    });
  };

  updateProductRow = (id, field, value) => {
    this.setState({
      productsArray: this.state.productsArray.map((product) =>
        product.id === id ? { ...product, [field]: value } : product,
      ),
    });
  };

  removeProductRow = (id) => {
    const removed = this.state.productsArray.find(
      (product) => product.id === id,
    );
    if (removed && removed.imageUrl) {
      deleteImage(removed.imageUrl);
    }
    this.setState({
      productsArray: this.state.productsArray.filter(
        (product) => product.id !== id,
      ),
    });
  };

  handleProductImageChange = async (id, file) => {
    if (!file) return;
    const existing = this.state.productsArray.find(
      (product) => product.id === id,
    );
    const imgUrl = existing && existing.imageUrl
      ? await updateImage(file, existing.imageUrl, "zapaiProducts")
      : await uploadImage(file, "zapaiProducts");
    if (imgUrl) {
      this.updateProductRow(id, "imageUrl", imgUrl);
    }
  };

  getProductsGrandTotal = () =>
    this.state.productsArray.reduce(
      (sum, product) =>
        sum +
        (parseFloat(product.priceRmb) || 0) *
          (parseFloat(product.quantity) || 0),
      0,
    );

  componentDidMount = async () => {
    this.props.getAllEmployeeRedux();
    await this.props.ensureCurrentMonthStatsRedux();
    this.props.getAllSourcingMonthStatsRedux();
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };
  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  handleSubmit = async () => {
    const date = new Date();
    if (this.state.customer === "") {
      alert("Please enter a customer name first");
      return;
    }
    const productsArray = this.state.productsArray.map((product) => ({
      ...product,
      totalRmb: (
        (parseFloat(product.priceRmb) || 0) *
        (parseFloat(product.quantity) || 0)
      ).toFixed(2),
    }));
    await this.props.uploadSourcingRedux({
      ...this.state,
      id: date.getTime().toString(),
      month: this.getMonthName(),
      date: date.toLocaleDateString("en-GB"),
      localWarehouseDateTimeStamp: firebase.firestore.Timestamp.now(),
      status: "pending",
      totalBill:
        parseInt(
          parseFloat(this.state.sellRate) * parseFloat(this.state.totalRmb),
        ) + parseInt(this.state.shipping || 0),
      category: "sourcing",
      invoiceStatus: "Not Paid",
      sourcingStatus: "Pending",
      productsArray,
      productName: productsArray.length > 0 ? productsArray[0].productName : "",
    });
    this.props.getAllSourcingMonthStatsRedux();

    const message = {
      title: `Order Invoice`,
      body: `A new Order invoice has been added to your account.Please check the information.`,
    };
    const userObj = this.props.allUsers.find(
      (user) => user.uid == this.state.customerUid,
    );
    if (userObj && userObj.deviceToken && userObj.deviceToken.length > 0) {
      userObj.deviceToken.map((token) => {
        sendNotifications(token, message);
      });
    }
    this.setState({
      agent: "",
      totalRmb: "",
      sellRate: "",
      buyRate: "",
      shipping: "",
      productLink: "",
      productDetails: "",
      productName: "",
      productsArray: [],
      totalPaid: 0,
      buyingCost: 0,
      finalProfit: 0,
      customer: "",
      customerUid: "",
      cursor: -1,
      country: "",
      agentPaid: 0,
      initialProfit: 0,
      algProfit: 0,
    });
  };

  render() {
    const { monthStats, allEmployees } = this.props;
    const currentMonth = this.getMonthName();
    const now = (monthStats || []).find((m) => m.month === currentMonth) || {};
    const tk = (v) => `৳ ${Math.round(Number(v || 0)).toLocaleString("en-IN")}`;
    const stats = [
      { label: "Invoices this month", value: (now.invoiceCount || 0).toLocaleString(), tone: "sky" },
      { label: "Billed", value: tk(now.totalBill), tone: "butter" },
      { label: "Paid", value: tk(now.totalPaid), tone: "mint" },
      { label: "KIDO profit", value: tk(now.totalZapaiProfit), tone: "lilac" },
    ];
    const currencyName = this.state.country == "INDIA" ? "Rupees" : "RMB";

    return (
      <div className="kd-ws">
        <Breadcrumb title="Monthly" parent="Wholesale Management/Order" />
        <div className="container-fluid">
          <section className="card kd-orders-card">
            <div className="kd-ord-top">
              <div className="kd-ord-title">
                <span className="kd-ord-title-tile kd-st--butter" aria-hidden="true">
                  <FileText size={20} />
                </span>
                <div>
                  <h2>Order invoices</h2>
                  <svg className="kd-squiggle" viewBox="0 0 120 10" aria-hidden="true" focusable="false">
                    <path d="M2 6 Q12 1 22 6 T42 6 T62 6 T82 6 T102 6 T118 5" />
                  </svg>
                </div>
              </div>
              <div className="kd-ws-actions">
                <button
                  type="button"
                  className="btn btn-light"
                  disabled={this.state.recalculating}
                  onClick={this.handleRecalculateStats}
                  title="Recompute every month's stats from scratch by re-scanning all invoices. Use this if the numbers on this page look out of sync."
                >
                  <RefreshCw size={15} aria-hidden="true" />
                  {this.state.recalculating
                    ? "Recalculating..."
                    : "Recalculate stats"}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-toggle="modal"
                  data-target="#personalInfoModal"
                  onClick={() => {
                    this.setState({
                      agent: "",
                      totalRmb: "",
                      sellRate: "",
                      buyRate: "",
                      productLink: "",
                      productDetails: "",
                      productName: "",
                      productsArray: [],
                      totalPaid: 0,
                      buyingCost: 0,
                      finalProfit: 0,
                      cursor: -1,
                      customer: "",
                      customerUid: "",
                    });
                  }}
                >
                  <Plus size={15} aria-hidden="true" />
                  New invoice
                </button>
              </div>
            </div>

            <div className="kd-ord-summary">
              <div className="kd-ord-stats kd-ws-stats">
                {stats.map(({ label, value, tone }, i) => (
                  <div key={label} className={`kd-stat-tag kd-st--${tone}`} style={{ "--i": i }}>
                    <span className="kd-stat-label">{label}</span>
                    <span className="kd-stat-value">{value}</span>
                  </div>
                ))}
              </div>
              <p className="kd-ws-scope">{currentMonth.replace(",", " ")}</p>
            </div>

            <div className="kd-ws-body">
              <Datatable
                history={this.props.history}
                myData={monthStats}
                currentMonth={currentMonth}
              />
            </div>
          </section>
        </div>
        <ToastContainer />

        {/* Create invoice */}
        <div
          className="modal fade tb-modal"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document" style={{ margin: "auto" }}>
            <div className="modal-content" style={{ top: 10, width: "95%", margin: "auto" }}>
              <div className="modal-header">
                <div className="modal-title" id="exampleModalLabel">
                  Create order invoice
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div>
                  <div className="kd-ws-form-grid">
                    <div className="form-group">
                      <label htmlFor="kd-ws-agent">Order agent</label>
                      <select
                        id="kd-ws-agent"
                        required
                        name="agent"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.agent}
                      >
                        <option value="">Select employee</option>
                        {allEmployees.map((employee) => (
                          <option key={employee.name} value={`${employee.name}`}>
                            {employee.name}-{employee.designation}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label htmlFor="kd-ws-country">Country</label>
                      <select
                        id="kd-ws-country"
                        required
                        name="country"
                        className="custom-select"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.country}
                      >
                        <option value="">Select country</option>
                        <option value="INDIA">India</option>
                        <option value="CHINA">China</option>
                      </select>
                    </div>

                    <div className="form-group is-wide">
                      <label htmlFor="kd-ws-customer">Customer name</label>
                      <input
                        id="kd-ws-customer"
                        type="text"
                        name="customer"
                        className="form-control"
                        placeholder="Enter customer name"
                        aria-required="true"
                        aria-invalid="false"
                        onChange={this.handleChange}
                        value={this.state.customer}
                        required
                        autoComplete="off"
                      />
                    </div>
                  </div>

                  {this.state.country ? (
                    <>
                      <div className="form-group">
                        <label>Products</label>
                        {this.state.productsArray.length > 0 ? (
                          <div
                            className="consultancy-packing-summary"
                            data-toggle="modal"
                            data-target="#packingListModal"
                            role="button"
                            tabIndex={0}
                          >
                            <img
                              className="consultancy-packing-thumb"
                              src={this.state.productsArray[0].imageUrl || man}
                              alt=""
                            />
                            <span className="consultancy-packing-name">
                              {this.state.productsArray[0].productName ||
                                "Unnamed product"}
                            </span>
                            {this.state.productsArray.length > 1 && (
                              <span className="consultancy-packing-more">
                                +{this.state.productsArray.length - 1} more
                                product
                                {this.state.productsArray.length - 1 === 1
                                  ? ""
                                  : "s"}
                              </span>
                            )}
                          </div>
                        ) : (
                          <button
                            type="button"
                            className="consultancy-packing-add-btn"
                            data-toggle="modal"
                            data-target="#packingListModal"
                          >
                            <Plus size={15} aria-hidden="true" />
                            Add products
                          </button>
                        )}
                      </div>

                      <div className="kd-ws-form-grid">
                        <div className="form-group is-wide">
                          <label htmlFor="kd-ws-total">Total {currencyName}</label>
                          <input
                            id="kd-ws-total"
                            type="number"
                            className="form-control"
                            name="totalRmb"
                            value={this.state.totalRmb}
                            onChange={this.handleChange}
                            placeholder="Total"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="kd-ws-sell">{currencyName} sell rate</label>
                          <input
                            id="kd-ws-sell"
                            type="number"
                            className="form-control"
                            name="sellRate"
                            value={this.state.sellRate}
                            onChange={this.handleChange}
                            placeholder="Sell rate"
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="kd-ws-buy">{currencyName} buy rate</label>
                          <input
                            id="kd-ws-buy"
                            type="number"
                            className="form-control"
                            name="buyRate"
                            value={this.state.buyRate}
                            onChange={this.handleChange}
                            placeholder="Buy rate"
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <span className="kd-ws-hint">
                      Pick a country to add products and rates.
                    </span>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-light" data-dismiss="modal">
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  Create invoice
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Products (packing list) */}
        <div
          className="modal fade tb-modal"
          id="packingListModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="packingListModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document" style={{ margin: "auto" }}>
            <div className="modal-content" style={{ margin: "auto" }}>
              <div className="modal-header">
                <div className="modal-title" id="packingListModalLabel">
                  Products
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                {this.state.productsArray.length === 0 && (
                  <div className="consultancy-packing-empty">
                    <span className="kd-ws-hint">
                      No products yet. Add one line per product; tap the picture to upload a photo.
                    </span>
                  </div>
                )}
                {this.state.productsArray.map((product, index) => (
                  <div className="consultancy-packing-row" key={product.id}>
                    <div className="consultancy-packing-row-image">
                      <img
                        src={product.imageUrl || man}
                        alt=""
                        title="Upload a photo"
                        onClick={() => {
                          document
                            .getElementById(`packing-image-input-${index}`)
                            .click();
                        }}
                      />
                      <input
                        id={`packing-image-input-${index}`}
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          this.handleProductImageChange(
                            product.id,
                            e.target.files[0],
                          );
                        }}
                      />
                    </div>
                    <input
                      type="text"
                      className="form-control consultancy-packing-input"
                      placeholder="Product name"
                      aria-label="Product name"
                      value={product.productName}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "productName",
                          e.target.value,
                        )
                      }
                    />
                    <input
                      type="number"
                      className="form-control consultancy-packing-input consultancy-packing-input--num"
                      placeholder="Price"
                      aria-label="Price (Rmb)"
                      value={product.priceRmb}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "priceRmb",
                          e.target.value,
                        )
                      }
                    />
                    <input
                      type="number"
                      className="form-control consultancy-packing-input consultancy-packing-input--num"
                      placeholder="Qty"
                      aria-label="Quantity"
                      value={product.quantity}
                      onChange={(e) =>
                        this.updateProductRow(
                          product.id,
                          "quantity",
                          e.target.value,
                        )
                      }
                    />
                    <div className="consultancy-packing-row-total">
                      {(
                        (parseFloat(product.priceRmb) || 0) *
                        (parseFloat(product.quantity) || 0)
                      ).toFixed(2)}{" "}
                      Rmb
                    </div>
                    <button
                      type="button"
                      className="consultancy-packing-row-remove"
                      aria-label="Remove product"
                      onClick={() => this.removeProductRow(product.id)}
                    >
                      <Trash2 size={15} aria-hidden="true" />
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="consultancy-packing-add-row-btn"
                  onClick={this.addProductRow}
                >
                  <Plus size={15} aria-hidden="true" />
                  Add product
                </button>

                <hr className="consultancy-modal-divider" />

                <div className="consultancy-packing-footer">
                  <div className="form-group consultancy-packing-shipping">
                    <label htmlFor="kd-ws-shipping">Shipping charge (all products)</label>
                    <input
                      id="kd-ws-shipping"
                      type="number"
                      className="form-control"
                      name="shipping"
                      placeholder="Enter shipping charge"
                      value={this.state.shipping}
                      onChange={this.handleChange}
                    />
                  </div>
                  <div className="consultancy-packing-grand-total">
                    <span className="consultancy-packing-grand-total-label">
                      Products total
                    </span>
                    <span className="consultancy-packing-grand-total-value">
                      {this.getProductsGrandTotal().toFixed(2)} Rmb
                    </span>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-primary" data-dismiss="modal">
                  Done
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allEmployees: state.employees.employees.filter(
      (employee) => employee.status == "Active",
    ),
    monthStats: state.sourcings.monthStats,
    allUsers: state.users.users,
  };
};

export default connect(mapStateToProps, {
  getAllEmployeeRedux,
  uploadSourcingRedux,
  getAllSourcingMonthStatsRedux,
  ensureCurrentMonthStatsRedux,
  recomputeSourcingMonthStatsRedux,
})(SoldMonth);
